import React, { useContext, useRef } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// utils
import { changeDateFormat, moneyFormatter } from "bodycodi/cmap/app/js/common";
import { api } from "bodycodi/cmap/app/js/api";

const ProgramCard = ({ type, openDetail, openShareAlert, setRefetch, ...props }: any) => {
  const { dispatch } = useContext(DispatchContext);
  const ref = useRef<any>(null);

  const handleImgLoad = () => {
    ref.current.classList.add("loaded");
  };

  const handleSuspendButton = () => {
    const alertSettings = props.hiddenDtm
      ? {
          alert: true,
          cancleYn: "G", // alert with green button on the right
          header: "프로그램 전시하기",
          greenButtonLabel: "전시하기",
          body: "바디코디 플러스 판매 프로그램을 \n 전시하시겠어요?",
          cancelAlert: () => ({}),
          closeAlert: () => {
            toggleProgramVisibility("Y");
          },
        }
      : {
          alert: true,
          cancleYn: "D", // alert with red button on the right
          header: "프로그램 전시중지",
          redButtonLabel: "전시중지",
          body: "바디코디 플러스 판매 프로그램을 \n 전시중지하시겠어요?",
          cancelAlert: () => {},
          closeAlert: () => {
            toggleProgramVisibility("N");
          },
        };

    dispatch({
      type: "ALERT_SETTING",
      data: alertSettings,
    });
  };

  const toggleProgramVisibility = async (displayYn: "Y" | "N") => {
    try {
      dispatch({ type: "LOADING_START" });
      await api
        .patch(`/plus/programs`, {
          displayYn,
          seqPlusProgram: props?.seqPlusProgram,
        })
        .then(() => {
          dispatch({ type: "LOADING_END" });
          dispatch({
            type: "ALERT_SETTING",
            data: {
              alert: true,
              cancleYn: false,
              header: displayYn === "N" ? "프로그램 전시중지 완료" : "프로그램 전시하기 완료",
              body:
                displayYn === "N"
                  ? "전시중지된 프로그램은 전시중지 탭에서 \n 전시중으로 변경할 수 있어요."
                  : "바디코디 플러스 판매 프로그램의 \n 전시가 완료되었어요.",
              cancelAlert: () => {},
              closeAlert: () => {
                setRefetch((prev: number) => prev + 1);
                if (type !== "list") {
                  dispatch({
                    type: "POP_UP_OPEN",
                    id: "PROGRAM_MANAGEMENT_DETAIL_POP",
                    open: { programManagementDetailPop: false },
                  });
                }
              },
            },
          });
        });
    } catch (error) {
      dispatch({ type: "LOADING_END" });
      console.error(error);
    }
  };

  return (
    <div className="program-card">
      <div className="contents">
        <div ref={ref} className="blurred-img">
          <img src={props?.mainCoverImgUrl} loading="lazy" onLoad={handleImgLoad} />
        </div>

        <div className="text">
          <span className="blue">
            {`${props?.defaultTeamTitle} ${
              props?.teamCount > 1 ? `외 ${props?.teamCount - 1}팀` : ""
            }`}
            <span className="gray">
              {props?.partnerName} {props?.branchName}
            </span>
          </span>
          <span className="title">{props?.title}</span>
          <span className="price">{moneyFormatter(props?.totalPrice)}</span>
          <span className="gray">{`${changeDateFormat(props?.saleStartDtm, true)} ~ ${
            props?.saleEndDtm === "9999-12-31T00:00:00"
              ? "미지정"
              : changeDateFormat(props?.saleEndDtm, true)
          }`}</span>
        </div>
      </div>

      {type === "list" ? (
        <div className="buttons">
          <button onClick={openShareAlert}>공유하기</button>
          <button onClick={openDetail}>상세정보</button>
          <button
            onClick={handleSuspendButton}
            className={`colored ${props?.hiddenDtm ? "green" : "red"}`}
          >
            {props?.hiddenDtm ? "전시하기" : "전시중지"}
          </button>
        </div>
      ) : (
        <div className="buttons">
          <button
            onClick={handleSuspendButton}
            className={`colored ${props?.hiddenDtm ? "green" : "red"}`}
          >
            {props?.hiddenDtm ? "전시하기" : "전시중지"}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProgramCard;
